import { create } from 'zustand';
import { createClimateSlice } from './climateSlice';
import type { ClimateSlice } from './climateSlice';
import { createGrowSlice } from './growSlice';
import type { GrowSlice } from './growSlice';
import { createSettingsSlice } from './settingsSlice';
import type { SettingsSlice } from './settingsSlice';
import { createActivitySlice } from './activitySlice';
import type { ActivitySlice } from './activitySlice';
import { createAutomationSlice } from './automationSlice';
import type { AutomationSlice } from './automationSlice';
import { createAISlice } from './aiSlice';
import type { AISlice } from './aiSlice';

export type AppState = ClimateSlice & GrowSlice & SettingsSlice & ActivitySlice & AutomationSlice & AISlice;

export const useAppStore = create<AppState>()((set, get, api) => ({
  ...createClimateSlice(set, get, api),
  ...createGrowSlice(set, get, api),
  ...createSettingsSlice(set, get, api),
  ...createActivitySlice(set, get, api),
  ...createAutomationSlice(set, get, api),
  ...createAISlice(set, get, api),
}));
